import { StrictMode } from "react"
import { createRoot, type Root } from "react-dom/client"
import { FuturesChart } from "@/components/chart/FuturesChart"
import type { FuturesChartData, FuturesChartPreferences } from "@/types/futuresChart"

let root: Root | null = null

function unmount(): void {
  root?.unmount()
  root = null
}

function mount(): void {
  const element = document.getElementById("react-futures-chart-root")
  if (!element) {
    unmount()
    return
  }

  unmount()
  const data = JSON.parse(element.dataset.chart ?? "{}") as FuturesChartData
  const preferences = JSON.parse(element.dataset.preferences ?? "{}") as FuturesChartPreferences
  const signedIn = element.dataset.signedIn === "true"

  root = createRoot(element)
  root.render(
    <StrictMode>
      <FuturesChart
        initialData={data}
        initialPreferences={preferences}
        signedIn={signedIn}
      />
    </StrictMode>,
  )
}

document.addEventListener("turbo:load", mount)
document.addEventListener("turbo:before-cache", unmount)
mount()
